<template>
  <div class="operation-item">
    <block-title title="下载模板" class="item-content">
      <a-row class="exportStyle">
        <div v-for="(pro, i) in productList" :key="i" :class="i !== 0 ? 'mar' : ''">
          <a-col v-for="(item, index) in pro" :key="index" :class="index === 1 ? 'leftStyle product-flg' : 'product-flg'" :span="11" :offset="0">
            <div
              :class="typeIndex === item.productCode ? 'radioBox radioBoxActive' : 'radioBox'"
              @click="editTypeIndex(item.productCode)"
            >
              <img v-if="typeIndex === item.productCode" class="activeImg" src="@/assets/img/icon_select.png" alt="">
              <div class="flex justify-between align-center">
                <p class="exportTitle">{{item.productName}}</p>
                <span v-if="item.tips" class="tips">{{ item.tips }}</span>
              </div>
              <p class="skuStyle">
                
                {{item.productCode === UPLOADTYPE.SETTLEMENT ? '表格中填写货品品类，不填写sku明细' : item.desc || `表格支持${item.productName}计费方式的下单`}}
              </p>
              <div
                v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-${item.productName}`:`批量导入下单-下载模板-${item.productName}`}"
                :class="{'batchBtnStyle': true, 'isActive': typeIndex === item.productCode}"
                @click="downloadExcelTemplate(item, item.productCode)"
              >
                <img src="@/assets/img/icon/xlsx.png" />
                {{item.productName}}下单模板
                <img class="icon_load" :src="typeIndex === item.productCode ? downloadField : downloads" />
            </div>
            </div>
          </a-col>
        </div>
        <template v-if="hasWarehouseContract">
          <template v-if="!isWmsSystem">
            <a-col :class="{'leftStyle': productList.length % 2 === 1, 'product-flg': true, 'pro-margin': true}" :span="11" :offset="0">
              <div
                :class="typeIndex === WAREHOUSETYPE.WAREHOUSE ? 'radioBox radioBoxActive' : 'radioBox'"
                @click="changeWarehoseType(WAREHOUSETYPE.WAREHOUSE, WAREHOUSETYPE.STORE_V2)"
              >
                <img v-if="typeIndex === WAREHOUSETYPE.WAREHOUSE" class="activeImg" src="@/assets/img/icon_select.png" alt="">
                <p class="exportTitle">仓下单</p>
                <p class="skuStyle">
                  运输入库、纯入库、纯出库
                </p>
                <div class="flex">
                  <div
                    v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓入库单模板`:`批量导入下单-下载模板-仓入库单模板`}"
                    class="batchBtnStyle"
                    icon="download"
                    :class="{'batchBtn': true, 'isActive': typeIndex === 'WAREHOUSE_ONLY' && type === WAREHOUSETYPE.STORE_V2}"
                    @click="(e) => changeWarehoseType(WAREHOUSETYPE.WAREHOUSE, WAREHOUSETYPE.STORE_V2, e)"
                  >
                    <img src="@/assets/img/icon/xlsx.png" />
                    仓入库单模板
                    <img
                      class="icon_load"
                      :src="typeIndex === WAREHOUSETYPE.WAREHOUSE && type === WAREHOUSETYPE.STORE_V2 ? downloadField : downloads"
                      @click="downloadTemplate('仓入库单模版', WAREHOUSETYPE.STORE_V2, true)"
                    />
                    </div>
                  <div
                    v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓出库单模板`:`批量导入下单-下载模板-仓出库单模板`}"
                    class="batchBtnStyle margin"
                    icon="download"
                    :class="{'batchBtn': true, 'isActive': typeIndex === 'WAREHOUSE_ONLY' &&  type === WAREHOUSETYPE.DELIVER_ONLY_V2}"
                    @click="e => changeWarehoseType(WAREHOUSETYPE.WAREHOUSE, WAREHOUSETYPE.DELIVER_ONLY_V2, e)"
                  >
                    <img src="@/assets/img/icon/xlsx.png" />
                    仓出库单模板
                    <img
                      class="icon_load"
                      :src="typeIndex === WAREHOUSETYPE.WAREHOUSE && type === WAREHOUSETYPE.DELIVER_ONLY_V2 ? downloadField : downloads"
                      @click="downloadTemplate('仓出库单模版', WAREHOUSETYPE.DELIVER_ONLY_V2, true)"
                    />
                  </div>
                </div>
              </div>
            </a-col>
            <a-col :class="{'leftStyle': productList.length % 2 === 0, 'product-flg': true, 'pro-margin': true}" :span="11" :offset="0">
              <div
                :class="typeIndex === WAREHOUSETYPE.TRANSPORT ? 'radioBox radioBoxActive' : 'radioBox'"
                @click="changeWarehoseType(WAREHOUSETYPE.TRANSPORT, WAREHOUSETYPE.DELIVER_TRANSPORT_V2)"
              >
              <img v-if="typeIndex === WAREHOUSETYPE.TRANSPORT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
                <p class="exportTitle">仓配一体下单</p>
                <p class="skuStyle">
                  出库与运输一体下单
                </p>
                <div>
                  <div
                      v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓配一体下单导入模板`:`批量导入下单-下载模板-仓配一体下单导入模板`}"
                    class="batchBtnStyle"
                    icon="download"
                    :class="{'batchBtn': true, 'isActive': type === WAREHOUSETYPE.DELIVER_TRANSPORT_V2}"
                  >
                    <img src="@/assets/img/icon/xlsx.png" />
                    仓配一体下单导入模版
                    <img
                      class="icon_load"
                      :src="typeIndex === WAREHOUSETYPE.TRANSPORT && type === WAREHOUSETYPE.DELIVER_TRANSPORT_V2 ? downloadField : downloads"
                      @click="downloadTemplate('仓配一体下单导入模版', WAREHOUSETYPE.DELIVER_TRANSPORT_V2, true)"
                    />
                    </div>
                </div>
              </div>
            </a-col>
          </template>
          <wmsWarehouseMultiple
            v-else
            :type-index="typeIndex"
            @downloadExcelWareHouse="downloadExcelWareHouse"
            @downloadExcelWareHouseTransport="downloadExcelWareHouseTransport"
            @editTypeIndex="editTypeIndex"
            @downloadTemplate="downloadTemplate"
            @changeWareHouseType="changeType"
            />
        </template>
      </a-row>
    </block-title>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import downloadField from '@/assets/img/icon/download_field.png'
import downloads from '@/assets/img/icon/download.png'
import { mapGetters } from 'vuex';
import { UPLOADTYPE, WAREHOUSETYPE, UsualToBusiness } from './multipleConst';
import wmsWarehouseMultiple from './wmsWarehouseMultiple/index.vue'

export default {
  name: 'StandardMultiple',
  components: {
    BlockTitle,
    wmsWarehouseMultiple,
  },
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    typeIndex: {
      type: String,
      default: ''
    },
    hasWarehouseContract: {
      type: Boolean,
      default: false,
    },
    isWmsSystem:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      UPLOADTYPE,
      downloadField,
      downloads,
      WAREHOUSETYPE,
      type: WAREHOUSETYPE.STORE_V2,
    }
  },
  computed:{
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
  },
  methods: {
    downloadExcelTemplate(item, index) {
      this.$emit('downloadExcelTemplate', item, index)
    },
    editTypeIndex(index) {
      this.$emit('editTypeIndex', index)
    },
    downloadExcelWareHouseTransport(name, type) {
      this.$emit('downloadExcelWareHouseTransport', name, type)
    },
    downloadExcelWareHouse(item, type) {
      this.$emit('downloadExcelWareHouse', item, type)
    },
    downloadTemplate(item, type, isTransport) {
      const innerType = this.isOrderDemoVersion? type : (UsualToBusiness[type]||type)
      this.$emit('downloadTemplate', item, innerType, isTransport)
    },
    changeWarehoseType(index, type, e) {
      this.$emit('editTypeIndex', index);
      this.type = type;
      this.$emit('changeWareHouseType', type);
      if (e) {
        e.stopPropagation();
      }
    },
    changeType(type) {
      this.$emit('changeWareHouseType', type);
    }
  }
}
</script>

<style scoped>
.tips {
  color: red;
}
.batchBtnStyle {
  flex: 1;
}
.margin {
  margin-left: 10px;
}
.pro-margin {
  margin-right: 20px;
}
</style>
